<template>
  <div>
    <error-alert-dialog
      :show-error-alert-dialog="showErrorAlertDialog"
      :error="error"
      @dismissClicked="dismissErrorDialog"
      @contactSupport="contactSupport"
      ></error-alert-dialog>

    <contact-support-email-dialog
      :show="showEmailDialog"
      :subject="emailSubject"
      :body="emailBody"
      @sendMail="sendMail"
      @dialogClose="showEmailDialog=false"
      ></contact-support-email-dialog>

    <send-email-item
      :send-mail-event="sendMailEvent"
      :send-email-request="sendEmailRequest"
      @sendMailEvent="onSendMailEvent"
      ></send-email-item>
  </div>
</template>

<script>
  import SendEmailItem from "./SendEmailItem";
  import AlertService from "../core/alert/AlertService";
  import ErrorAlertDialog from "../dialogs/ErrorAlertDialog";
  import ContactSupportEmailDialog from "../dialogs/ContactSupportEmailDialog";
  import PrefManager from "../../data/model/PrefManager";
  import LoanScopeDataHolder from "../../data/model/LoanScopeDataHolder";
  import { MessageConstants } from "../../utils/MessageConstantUtil";
  import AuthenticationService from "../core/authentication/AuthenticationService";
  import UrlParams from "../../data/model/UrlParams";
  import ActivityNavigator, { Activities } from "../../utils/ActivityNavigator";
  import EzUtils from "@/utils/EzUtils";
  import { Constants } from '../Constants';
  import { environment } from "@/environments/environment";

  const FAILED_TO_UPDATE_LOAN_ERROR = "Failed to update loan information. Please contact support";
  const INTERNAL_500_ERROR = "500 Internal Server Error";
  const CREDENTIALS_REQUIRED_ERROR = "Credentials are required to access this resource.";

  export default {
    name: "ErrorAlertItem",
    components: { ErrorAlertDialog, ContactSupportEmailDialog, SendEmailItem },
    props: {
      logoutOnNetworkError: {
        type: Boolean,
        default: true,
      },

      errorAlertEvent: {
        type: Boolean,
        required: true,
        default: false,
      },

      networkError: {
        type: Object,
        required: true
      },

      emailTo: {
        type: Array,
        default: () => [environment.contactSupportEmail]
      },

      emailFrom: {
        type: String,
        default: environment.noReplyEmail
      },

    },

    methods: {
      dismissErrorDialog() {
        this.showErrorAlertDialog = false;
        this.$emit("resetErrorAlertEvent", {})
      },

      contactSupport(e) {
        this.showErrorAlertDialog = false;
        this.emailSubject = e.title;
        this.emailBody = e.description;
        this.showEmailDialog = true;
        this.$emit("resetErrorAlertEvent", {})
      },

      sendMail(e) {
        this.showEmailDialog = false;
        this.sendEmailRequest = {
          'to': this.emailTo,
          'from': this.emailFrom,
          'subject': `Need Support in weex app: ${e.subject}`,
          'body': `${this.getUserDescription()} \n ${this.getLoanDescription()} \n Message By User: ${e.body}`
        };
        this.sendMailEvent = true;
      },

      onSendMailEvent(sendEmailRes) {
        this.sendMailEvent = false;
        if (sendEmailRes.errorOccurred) {
          AlertService.showToast(MessageConstants.EMAIL_NOT_SENT);
          this.error = sendEmailRes.data;
          this.showErrorAlertDialog = true;
        } else {
          AlertService.showToast(MessageConstants.EMAIL_SENT);
        }
      },

      getUserDescription() {
        let appUserDetails = "App User Details :";
        appUserDetails = appUserDetails + " User Id-" + PrefManager.getUserId();
        appUserDetails = appUserDetails + ", User Mobile-" + PrefManager.getUserMobile();
        return appUserDetails;
      },

      getLoanDescription() {
        let loanDetails = "Loan Details :";
        loanDetails = loanDetails + " Client Id-" + LoanScopeDataHolder.getClientId();
        loanDetails = loanDetails + ", Loan Id-" + LoanScopeDataHolder.getLoanId();
        loanDetails = loanDetails + ", Mobile-" + LoanScopeDataHolder.getMobile();
        if (LoanScopeDataHolder.getCurrentLoanTask()) {
          loanDetails = loanDetails + ", Task-" + LoanScopeDataHolder.getCurrentLoanTask().name;
        }

        return loanDetails;
      }
    },
    data: () => ({
      showErrorAlertDialog: false,
      error: {},
      showEmailDialog: false,
      sendMailEvent: false,
      sendEmailRequest: {},
      emailSubject: "",
      emailBody: ""
    }),

    watch: {
      errorAlertEvent() {
        if (this.errorAlertEvent) {
          const error = this.networkError ? this.networkError : {};

          if (error.logoutOnError) {
            if (error.toastMessageOnLogout) {
              AlertService.showToast(error.toastMessageOnLogout);
            }
            AuthenticationService.logoutAndClearLocalStorageData();
            ActivityNavigator.navigateTo(Activities.LOGIN);
            return;
          }

          let title = error.title;
          if (EzUtils.areEqualString(INTERNAL_500_ERROR, title, true)
              || EzUtils.areEqualString(FAILED_TO_UPDATE_LOAN_ERROR, title, true)
          ) {
            this.error = {
              title: "Error!",
              description: "Looks like we encountered an unexpected issue. Please give us sometime, our team is looking at the issue."
            };
          } else if (EzUtils.areEqualString(CREDENTIALS_REQUIRED_ERROR, title, true)) {
            this.error = {title: "Looks like you are logged out, please login again."};
          } else {
            this.error = error;
          }
          this.showErrorAlertDialog = true;

          //TODO @anish check if we can distinguish timeout error and invalid auth. both return Network Error.
  /*        if (EzUtils.areEqualString("Network Error", title, true)
              && this.logoutOnNetworkError
          ) {
            AlertService.showToast(MessageConstants.SESSION_EXPIRED_LOGIN_TO_CONTINUE);
            AuthenticationService.logout();
            PrefManager.clearPrefs();
            LoanScopeDataHolder.clearLoanScopeData();
            UrlParams.clearUrlData();
            ActivityNavigator.navigateTo(Activities.LOGIN);
          } else {
            if (EzUtils.areEqualString(INTERNAL_500_ERROR, title, true)
                || EzUtils.areEqualString(FAILED_TO_UPDATE_LOAN_ERROR, title, true)
            ) {
              this.error = {
                title: "Oops!",
                description: "Looks like we encountered an expected issue. Please give us sometime, our team is looking at the issue."
              };
            } else if (EzUtils.areEqualString(CREDENTIALS_REQUIRED_ERROR, title, true)) {
              this.error = {title: "Looks like you are logged out, please login again."};
            } else {
              this.error = error;
            }
            this.showErrorAlertDialog = true;
          }*/
        }
      }
    }
  };
</script>

<style scoped>

</style>
